module.exports = __webpack_public_path__ + "img/icon-warning.bce1a1f2.svg";